// extracted by mini-css-extract-plugin
module.exports = {"root":"Skills_root__1tKvE","top":"Skills_top__IYVdN","details":"Skills_details__1CG-e","row":"Skills_row__1Zf8C","students":"Skills_students__3hUpi","back":"Skills_back__1O97R"};